module.exports = __webpack_public_path__ + "static/media/default-avatar.a1275211.svg";